import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
  member_data: any[];
  main_data: any[];
  representative_data: any[];
}

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

console.log(API_BASE_URL);
const getData = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_affiliate_corporate_membership_registration/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getDataForExcel = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_affiliate_corporate_membership_registration_list_excel/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getCommitteeType = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_committee_types/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const saveRow = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_edit_corporate_members_application/`,
      payload
    );
    return data;
  } catch (error) {}
};

const saveRowSubCol = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_edit_corporate_representative_members/`,
      payload
    );
    return data;
  } catch (error) {}
};

const approveMembership = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_approve_membership/`,
      payload
    );
    return data;
  } catch (error) {}
};

const removeMembership = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_remove_corporate_membership/`,
      payload
    );
    return data;
  } catch (error) {}
};

const deleteRow = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_delete_corporate_membership_registration/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getInfo = async (rowId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_corporate_info/`,
      rowId
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getContractPaymentInfo = async (rowId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_corporate_contract_payment_info/`,
      rowId
    );
    return data;
  } catch (error) {
    return error;
  }
};

const renewMembership = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/renew_corporate_membership/`,
      payload
    );
    return data;
  } catch (error) {}
};

const getMemberInfo = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_member_info/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const registerMemberUser = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/register_member_user/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const deactivateMembership = async (payload: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/deactivate_membership/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const reactivateMembership = async (payload: any) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/reactivate_membership/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const AffiliateCorporateMembershipController = {
  getData,
  getDataForExcel,
  saveRow,
  approveMembership,
  removeMembership,
  deleteRow,
  saveRowSubCol,
  getCommitteeType,
  getInfo,
  getContractPaymentInfo,
  renewMembership,
  getMemberInfo,
  registerMemberUser,
  deactivateMembership,
  reactivateMembership,
};
export default AffiliateCorporateMembershipController;
